import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { eventoRitualOutonoAtivo } from '../utils/campanhas';
import { registarEvento } from '../utils/analytics';
import { EVENTO } from '../data/evento';
import fotoEvento from '../assets/eventos/ritual-outono.jpg';

const ATRASO_MS = 2000; // só abre depois de o visitante ver a página
const SILENCIO_MS = 24 * 60 * 60 * 1000; // depois de fechar, não volta a aparecer durante 24 horas
const CHAVE_STORAGE = `popup_${EVENTO.chave}`;

function jaFechado() {
  try {
    const ate = Number(localStorage.getItem(CHAVE_STORAGE) || 0);
    return Date.now() < ate;
  } catch (err) {
    return false;
  }
}

function lembrarFecho() {
  try {
    localStorage.setItem(CHAVE_STORAGE, String(Date.now() + SILENCIO_MS));
  } catch (err) {
    // sem armazenamento: o pop-up volta ao recarregar, não faz mal
  }
}

// Pop-up da Home a convidar para o evento. Só aparece durante a campanha (ver utils/campanhas.js).
export default function PopupEvento() {
  const [aberto, setAberto] = useState(false);
  const botaoRef = useRef(null);

  useEffect(() => {
    if (!eventoRitualOutonoAtivo() || jaFechado()) return undefined;
    const id = setTimeout(() => setAberto(true), ATRASO_MS);
    return () => clearTimeout(id);
  }, []);

  function fechar() {
    lembrarFecho();
    setAberto(false);
  }

  useEffect(() => {
    if (!aberto) return undefined;
    const overflowOriginal = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    const aoTeclar = (e) => {
      if (e.key === 'Escape') {
        lembrarFecho();
        setAberto(false);
      }
    };
    window.addEventListener('keydown', aoTeclar);
    if (botaoRef.current) botaoRef.current.focus();
    return () => {
      document.body.style.overflow = overflowOriginal;
      window.removeEventListener('keydown', aoTeclar);
    };
  }, [aberto]);

  if (!aberto) return null;

  return (
    <div
      className="fixed inset-0 z-[80] flex items-center justify-center px-4 py-6 overflow-y-auto"
      style={{ backgroundColor: 'rgba(20,19,17,0.7)' }}
      onClick={fechar}
    >
      <div
        role="dialog"
        aria-modal="true"
        aria-label={EVENTO.titulo}
        className="relative w-full max-w-md rounded-2xl overflow-hidden shadow-2xl"
        style={{ backgroundColor: '#FEFEFD' }}
        onClick={(e) => e.stopPropagation()}
      >
        <button
          type="button"
          aria-label="Fechar"
          onClick={fechar}
          className="absolute top-3 right-3 z-10 w-9 h-9 rounded-full flex items-center justify-center text-xl leading-none"
          style={{ backgroundColor: 'rgba(254,254,253,0.9)', color: '#2E2C29' }}
        >
          &times;
        </button>

        <img
          src={fotoEvento}
          alt="Taças tibetanas e de cristal no espaço Márcia Monteiro"
          className="w-full h-48 sm:h-56 object-cover"
          style={{ objectPosition: 'center 40%' }}
        />

        <div className="p-6 text-center">
          <div className="text-xs font-semibold tracking-[0.15em] uppercase mb-2" style={{ color: '#B89547' }}>{EVENTO.data}</div>
          <h2 className="text-2xl font-semibold mb-2" style={{ color: '#2E2C29' }}>{EVENTO.titulo}</h2>
          <p className="text-sm mb-4" style={{ color: '#706b63' }}>{EVENTO.subtitulo}</p>
          <div className="flex flex-wrap justify-center gap-2 mb-6">
            {EVENTO.detalhes.map(d => (
              <span key={d} className="text-xs font-semibold px-3 py-1 rounded-full" style={{ backgroundColor: '#FFF9EE', border: '1px solid #DCCCA0', color: '#9A7C38' }}>{d}</span>
            ))}
          </div>
          <Link
            ref={botaoRef}
            to={EVENTO.artigo}
            onClick={() => {
              registarEvento('clique_popup_evento', { evento: EVENTO.chave });
              fechar();
            }}
            className="inline-block w-full sm:w-auto px-8 py-3 rounded-full text-sm font-semibold shadow transition hover:opacity-90"
            style={{ backgroundColor: '#B89547', color: '#FEFEFD' }}
          >
            Quero inscrever-me
          </Link>
          <div className="mt-3">
            <button type="button" onClick={fechar} className="text-xs hover:underline" style={{ color: '#706b63' }}>Agora não</button>
          </div>
        </div>
      </div>
    </div>
  );
}
